import React, { Fragment, useEffect, useRef, useState } from 'react';
import LayoutComp from 'components/LayoutComp/Index';
import { STATIC_TEXT } from 'utils/constants';
import { BackArrow } from 'utils/svg';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useDispatch, useSelector } from 'react-redux';
import {
  Badge,
  Button,
  Col,
  Drawer,
  Form,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Typography
} from 'antd';
import {
  CloudDownloadOutlined,
  HomeOutlined,
  LeftOutlined,
  MenuOutlined,
  RightOutlined
} from '@ant-design/icons';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import './styles.scss';

NoDataToDisplay(Highcharts);

import {
  fetchExcelData,
  fetchquestionnaireNamesReports,
  fetchSurveyChartData,
  fetchSurveyFilters,
  fetchSurveyQues,
  fetchSurveyQuesCrossTab,
  fetchYears,
  getChartOptions,
  resetdata,
  fetchclientNamesReports
} from './reports.action';
import {
  createChartData,
  filterObj,
  createTabledata,
  getAdjacentObjectId,
  getFirstAndLastQuestionId,
  removeWhiteSpace,
  exportTableToExcel
} from 'utils/functions';
import Loader from 'components/ui/Loader';
import SearchQues from 'components/ui/SearchQues';
import { downloadPPTmulti } from './downloadPPT';
// import { fetchCategories } from 'containers/QuestionCategory/category.action';
// import ExportToExcel from 'components/ui/DownloadExcel';

// Highcharts.setOptions({
//   colors: [
//     '#7438f2',
//     '#ff6319',
//     '#009150',
//     '#9333ea',
//     '#c026d3',
//     '#ffcc00',
//     '#0088cc',
//     '#b71c1c',
//     '#1e88e5',
//     '#f06292',
//     '#6d4c41',
//     '#26a69a'
//   ]
// });

const baseColors = [
  '#7438f2',
  '#009150',
  '#FF7F0E',

  '#1F77B4',

  '#D62728',

  '#9467BD',

  '#8C564B',

  '#E377C2',
  '#7F7F7F',
  '#BCBD22',
  '#17BECF',
  '#F5A623',
  '#4E79A7',
  '#6fcf61',
  '#E15759',
  '#76B7B2',
  '#136213'
];

const extendedColors = [...baseColors];

// Generate more colors by modifying existing ones
for (let i = 0; i < baseColors.length; i++) {
  extendedColors.push(
    Highcharts.Color(baseColors[i])
      .brighten(i * 0.1)
      .get()
  );
}

Highcharts.setOptions({ colors: extendedColors });

const viewoptions = [
  { label: 'Chart View', value: 1 },
  { label: 'Table View', value: 2 }
];

const Reports = ({ history }) => {
  const dispatch = useDispatch();
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedQuestionaire, setSelectedQuestionaire] = useState('');
  // const [client, setClient] = useState('');
  const [selectedQues, setSelectedQues] = useState('');
  const [currentView, setCurrentView] = useState(1);
  const [changedValue, setChangedValue] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({});
  const [chartHeight, setChartHeight] = useState(window.innerHeight * 0.5);
  const [isSearch, setIsSearch] = useState(false);
  const [form] = Form.useForm();
  const [selectedQuesCrossTab, setSelectedQuesCrossTab] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFullSurvey, setIsFullSurvey] = useState(1);
  const [qType, setQType] = useState(null);
  const [currentQues, setCurrentQues] = useState();

  const reportStates = useSelector((state) => state.reports);
  const {
    loading,
    chartLoader = false,
    questionnaireNames = [],
    clientNames = [],
    surveyQues = [],
    filtersData = [],
    filterLoader,
    chartData = {},
    years = [],
    surveyQuesCrosstab = []
  } = reportStates;
  const chartAreaRef = useRef(null);
  // console.log(clientNames, "abchddk")
  // console.log(questionnaireNames, "abchddk")
  // Fetch questionnaire names on mount
  useEffect(() => {
    dispatch(fetchYears());
  }, [dispatch]);

  useEffect(() => {
    if (years.length > 0) {
      const firstyear = years[0];
      setSelectedYear(firstyear);
    }

    // eslint-disable-next-line
  }, [years]);

  useEffect(() => {
    // if (years.length > 0) {
    //   const firstyear = years[0];
    //   setSelectedYear(firstyear);
    // }

    // eslint-disable-next-line
  }, [questionnaireNames, clientNames]);

  useEffect(() => {
    const handleResize = () => setChartHeight(chartAreaRef.current.clientHeight);
    if (years.length > 0) {
      dispatch(fetchquestionnaireNamesReports({ year: years[0], client: '' }));
      handleResize();
      window.addEventListener('resize', handleResize);
    }
    if (years.length > 0) {
      dispatch(fetchclientNamesReports(years[0]));
    }

    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line
  }, [dispatch, years]);

  // Fetch survey data when questionnaire names are loaded
  useEffect(() => {
    return () => {
      setSelectedQues('');
      dispatch(resetdata());
    };
    // eslint-disable-next-line
  }, []);

  // console.log('isSearch', isSearch);

  // Fetch question and filter data when survey questions are loaded
  useEffect(() => {
    if (surveyQues.length > 0 && !isSearch) {
      const firstqes = surveyQues[0];
      const qid = firstqes.id;
      setSelectedQues(qid);
      setCurrentQues((surveyQues.find(item => item.id === qid))?.text)
      const chartdataPayload = filterObj(
        selectedFilter,
        [...filtersData],
        qid,
        selectedQuestionaire
      );
      dispatch(fetchSurveyChartData(chartdataPayload));
    }

    // eslint-disable-next-line
  }, [surveyQues]);

  // Fetch actions based on selected questionnaire
  const executeActions = async (id) => {
    setSelectedQuestionaire(id);
    await dispatch(fetchSurveyQues(id));
    await dispatch(fetchSurveyQuesCrossTab(id));
    await dispatch(fetchSurveyFilters(id));
  };

  const handleBack = () => {
    history.push('/');
  };
  // Sample data for the column chart

  const handleYearChange = (val) => {
    // console.log(val, 'abd')
    setSelectedYear(val);
    setSelectedQuestionaire('');
    setSelectedFilter({});
    setSelectedQues('');
    dispatch(fetchquestionnaireNamesReports({ year: val, client: '' }));
    // handleResize();
    // window.addEventListener('resize', handleResize);
    dispatch(fetchclientNamesReports(val));
  };

  // const handleClientChange = (val) => {
  //   // console.log(val)
  //   setClient(val);
  //   setSelectedQuestionaire('');
  //   setSelectedFilter({});
  //   setSelectedQues('');
  //   // setClient(val)
  // };

  const handleQuestionaireChange = (val) => {
    executeActions(val);
    setSelectedFilter({});
    setSelectedQues('');
  };
  const handleQuestionChange = (val) => {
    setSelectedQues(val);
    setCurrentQues((surveyQues.find(item => item.id === val))?.text)

    const chartdataPayload = filterObj(
      selectedFilter,
      [...filtersData],
      val,
      selectedQuestionaire,
      false,
      selectedQuesCrossTab
    );
    if (!isSearch) {
      dispatch(fetchSurveyChartData(chartdataPayload));
    }
  };
  // console.log(currentQues, "current")
  const handleQuestionChangeCrossTab = (val) => {
    setSelectedQuesCrossTab(val == undefined ? '' : val);
    const chartdataPayload = filterObj(
      selectedFilter,
      [...filtersData],
      selectedQues,
      selectedQuestionaire,
      false,
      val
    );
    // chartdataPayload['cqId'] = val;
    // console.log('chartdataPayload', chartdataPayload);
    if (!isSearch) {
      dispatch(fetchSurveyChartData(chartdataPayload));
    }
  };

  const handleNextQues = (direction) => {
    const adjacenttId = getAdjacentObjectId(surveyQues, selectedQues, direction);
    handleQuestionChange(adjacenttId);
  };

  const handleHomeButtonClick = () => {
    const firstquesId = surveyQues[0].id;
    handleQuestionChange(firstquesId);
  };

  const handleViewChange = (e) => {
    const selectedview = e.target.value;
    setCurrentView(selectedview);
  };

  // Handler for form submission (Apply Filters)
  const onFinish = (values) => {
    setSelectedFilter(values);
    setChangedValue([]);
    const chartdataPayload = filterObj(
      values,
      [...filtersData],
      selectedQues,
      selectedQuestionaire,
      false,
      selectedQuesCrossTab
    );
    if (!isSearch) {
      dispatch(fetchSurveyChartData(chartdataPayload));
    }
  };

  // Reset filter form and fetch default chart data
  const handleClear = () => {
    form.resetFields(); // Reset all fields in the form
    setChangedValue([]);
    setSelectedFilter({});
    const formvalue = form.getFieldsValue();
    const chartdataPayload = filterObj(
      formvalue,
      [...filtersData],
      selectedQues,
      selectedQuestionaire,
      false,
      selectedQuesCrossTab
    );
    if (!isSearch) {
      dispatch(fetchSurveyChartData(chartdataPayload));
    }
  };

  // Handle changes in filter fields
  const handleonFieldChange = (changedField) => {
    const fieldname = changedField[0]['name'][0];
    if (!changedValue.includes(fieldname)) {
      // If not, add the new item to the array
      setChangedValue((prevItems) => [...prevItems, fieldname]);
    }
  };
  const updateSearchData = async (searchSelectedItem) => {
    setIsSearch(true);
    // console.log('searchSelectedItem', searchSelectedItem);
    const { qId, studyId, year } = searchSelectedItem;

    await setSelectedYear(year);
    await dispatch(fetchquestionnaireNamesReports(year));
    await setSelectedQuestionaire(studyId);
    setSelectedFilter({});
    await dispatch(fetchSurveyQues(studyId));
    await dispatch(fetchSurveyFilters(studyId));
    setSelectedQues(qId);
    const chartdataPayload = filterObj(
      selectedFilter,
      [...filtersData],
      qId,
      studyId,
      false,
      selectedQuesCrossTab
    );
    dispatch(fetchSurveyChartData(chartdataPayload));

    return setIsSearch(false);
  };

  const isMultiTable =
    (selectedQuesCrossTab != '' && chartData.qType == 9) ||
      chartData.qType == 10 ||
      chartData.qType == 4
      ? true
      : false;
  const {
    columns = [],
    tableData = [],
    crossMulti = {}
  } = createTabledata(chartData, isMultiTable);

  const handleCancel = () => {
    setQType(null);
    setIsFullSurvey(1);
    setIsModalOpen(false);
  };

  const singleDownload = (fileName, type, isCrossTab) => {
    if (type == 'pptx') {
      downloadPPTmulti([chartData], fileName, isCrossTab, isMultiTable);
    } else {
      exportTableToExcel('tbl2excel', fileName);
    }
  };

  const [isSidebarVisible, setSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  const handleExcelDownload = (type, isModal = false) => {
    const selectedQuestionaireNameObj = questionnaireNames.filter(
      (item) => item.id == selectedQuestionaire
    );

    const chartdataPayload = filterObj(
      selectedFilter,
      [...filtersData],
      selectedQues,
      selectedQuestionaire,
      true
    );
    if (selectedQuesCrossTab != '' || isFullSurvey == 1) {
      const fileName = removeWhiteSpace(selectedQuestionaireNameObj[0].name);
      singleDownload(fileName, type, selectedQuesCrossTab == '' ? false : true);

      // if (type == 'pptx') {
      //   downloadPPTmulti(
      //     [chartData],
      //     fileName,
      //     selectedQuesCrossTab == '' ? false : true,
      //     isMultiTable
      //   );
      // } else {
      //   exportTableToExcel('tbl2excel', fileName);
      // }
    } else {
      dispatch(fetchExcelData(chartdataPayload, type, selectedQuestionaireNameObj[0]));
    }
    if (isModal) {
      setIsModalOpen(false);
      setQType(null);
      setIsFullSurvey(1);
    }
  };

  const onChange = (e) => {
    setIsFullSurvey(e.target.value);
  };
  // console.log(surveyQues, "ques")
  const { firstQuestionId, lastQuestionId } = getFirstAndLastQuestionId(surveyQues);

  return (
    <div className="reports">
      <LayoutComp showsubheader={false} isReport={true} history={history}>
        {chartLoader && <Loader />}
        {loading && <Loader />}
        <div id="surveyType">
          {/* <aside className="sidebar">
            <div className="back-nav">
              <div onClick={handleBack}>
                <BackArrow />
              </div>
              {STATIC_TEXT['HFS_SURVEY_INSIGHTS']}
            </div>
            <div className="filters">
              <h2>Filter</h2>
              {!filterLoader ? (
                <Form
                  form={form}
                  name="filters"
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off"
                  onFieldsChange={handleonFieldChange}
                >
                  <div className="filterresize">
                    {filtersData?.map((item) => {
                      return (
                        <Form.Item
                          name={item.id}
                          label={
                            item.title != ''
                              ? `[${item.id}] ${item.title}`
                              : `[${item.id}] ${item.text}`
                          }
                          key={item.id}
                          style={{ marginBottom: 12 }}
                        >
                          <Select
                            mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Please select"
                            showSearch={false}
                            tokenSeparators={[]} // Disable displaying tags
                            options={item?.options?.map((option) => {
                              return { label: option.text, value: option.preCode };
                            })}
                          />
                        </Form.Item>
                      );
                    })}
                  </div>
                  {filtersData && filtersData.length > 0 && (
                    <Form.Item label={null} className="filterbuttons">
                      <Button htmlType="button" onClick={handleClear} style={{ marginRight: 15 }}>
                        Clear all
                      </Button>
                      <Badge count={changedValue.length}>
                        <Button type="primary" htmlType="submit">
                          Apply
                        </Button>
                      </Badge>
                    </Form.Item>
                  )}
                </Form>
              ) : (
                <div className="filterloading">Loading...</div>
              )}
            </div> */}
          {/* </aside> */}
          {/* Hamburger Menu for Mobile */}
          <div className="hamburger-menu">
            <MenuOutlined style={{ fontSize: "30px", cursor: "pointer" }} onClick={toggleSidebar} />
          </div>


          {/* Sidebar - Use Ant Design Drawer for Mobile */}
          <Drawer
            title="Filters"
            placement="left"
            closable={true}
            onClose={toggleSidebar}
            open={isSidebarVisible}
            width={400}
          >
            <div className="filters">
              <h2>Filter</h2>
              {!filterLoader ? (
                <Form form={form} name="filters" layout="vertical" onFinish={onFinish} autoComplete="off" onFieldsChange={handleonFieldChange}>
                  <div className="filterresize">
                    {filtersData?.map((item) => (
                      <Form.Item
                        name={item.id}
                        label={item.title ? `[${item.id}] ${item.title}` : `[${item.id}] ${item.text}`}
                        key={item.id}
                        style={{ marginBottom: 12 }}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Please select"
                          showSearch={false}
                          tokenSeparators={[]} // Disable displaying tags
                          options={item?.options?.map((option) => ({
                            label: option.text,
                            value: option.preCode,
                          }))}
                        />
                      </Form.Item>
                    ))}
                  </div>
                  {filtersData && filtersData.length > 0 && (
                    <Form.Item label={null} className="filterbuttons">
                      <Button htmlType="button" onClick={handleClear} style={{ marginRight: 15 }}>
                        Clear all
                      </Button>
                      <Badge count={changedValue.length}>
                        <Button type="primary" htmlType="submit">
                          Apply
                        </Button>
                      </Badge>
                    </Form.Item>
                  )}
                </Form>
              ) : (
                <div className="filterloading">Loading...</div>
              )}
            </div>
          </Drawer>

          {/* Sidebar for Desktop */}
          <aside className="sidebar">
            <div className="back-nav">
              <div onClick={handleBack}>
                <BackArrow />
              </div>
              {STATIC_TEXT["HFS_SURVEY_INSIGHTS"]}
            </div>
            <div className="filters">
              <h2>Filter</h2>
              {!filterLoader ? (
                <Form form={form} name="filters" layout="vertical" onFinish={onFinish} autoComplete="off" onFieldsChange={handleonFieldChange}>
                  <div className="filterresize">
                    {filtersData?.map((item) => (
                      <Form.Item
                        name={item.id}
                        label={item.title ? `[${item.id}] ${item.title}` : `[${item.id}] ${item.text}`}
                        key={item.id}
                        style={{ marginBottom: 12 }}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Please select"
                          showSearch={false}
                          tokenSeparators={[]} // Disable displaying tags
                          options={item?.options?.map((option) => ({
                            label: option.text,
                            value: option.preCode,
                          }))}
                        />
                      </Form.Item>
                    ))}
                  </div>
                  {filtersData && filtersData.length > 0 && (
                    <Form.Item label={null} className="filterbuttons">
                      <Button htmlType="button" onClick={handleClear} style={{ marginRight: 15 }}>
                        Clear all
                      </Button>
                      <Badge count={changedValue.length}>
                        <Button type="primary" htmlType="submit">
                          Apply
                        </Button>
                      </Badge>
                    </Form.Item>
                  )}
                </Form>
              ) : (
                <div className="filterloading">Loading...</div>
              )}
            </div>
          </aside>
          <div className="reportsection">
            <div className="header-bot">
              <div className="topfields">
                <div className="yearsection">
                  <span className="label">Select Year</span>
                  <Select
                    size="medium"
                    onChange={handleYearChange}
                    className="responsive-select1"
                    value={selectedYear}
                    style={{ width: '100%' }}
                    options={years.map((item) => ({ value: item, label: item }))}
                  />
                </div>
                <div className="questionnairesection">
                  <span className="label"> Select Questionnaire</span>
                  <Select
                    id="questionnaireselect"
                    size="medium"
                    placeholder="Select questionnaire"
                    onChange={handleQuestionaireChange}
                    className="responsive-select1"
                    value={selectedQuestionaire || undefined}
                    style={{ width: '100%' }} // Make Select take full width of its column
                    options={questionnaireNames.map((item) => ({
                      value: item.id,
                      label: item.name
                    }))}
                  />
                </div>
                <div className="search_btn">
                  <div className="search">
                    <SearchQues updateSearchData={updateSearchData} />
                  </div>

                  <div className="downloadbtn">
                    <Button
                      type="default"
                      icon={<CloudDownloadOutlined />}
                      size="middle"
                      onClick={() => {
                        if (selectedQuesCrossTab == '') {
                          setIsModalOpen(true);
                          setQType('excel');
                        } else {
                          handleExcelDownload('excel');
                        }
                      }}
                      disabled={selectedQues === ''}
                      style={{ marginRight: 15, marginTop: 24 }}
                    >
                      Excel
                    </Button>

                    <Button
                      type="default"
                      icon={<CloudDownloadOutlined />}
                      size="middle"
                      disabled={selectedQues === ''}
                      onClick={() => {
                        if (selectedQuesCrossTab == '') {
                          setIsModalOpen(true);
                          setQType('pptx');
                        } else {
                          handleExcelDownload('pptx');
                        }
                      }}
                    >
                      PPT
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="qSelection">
              <Row gutter={[12, 12]}>
                <Col xs={24} md={15} className="text-left">
                  {/* <div className="q-resize"> */}
                  <Typography className="responsive-text" title="Select the question you would like to visualize as chart">
                    Select the question you would like to visualize as chart
                  </Typography>
                  <Select
                    id="question"
                    size="medium"
                    className="responsive-select"
                    onChange={handleQuestionChange}
                    placeholder="Select question"
                    style={{ width: '100%' }}
                    value={selectedQues || undefined}
                    showSearch={true}
                    options={surveyQues.map((item) => {
                      return {
                        value: item.id,
                        label:
                          item.title != ''
                            ? `[${item.id}] ${item.title}`
                            : `[${item.id}] ${item.text}`
                      };
                    })}
                  />
                </Col>

                <Col xs={24} md={9} className="text-left">
                  <Typography className="responsive-text" title="Select the question to cross tabulate">
                    Select the question to cross tabulate
                  </Typography>
                  <Select
                    size="medium"
                    allowClear={true}
                    placeholder="Select question"
                    disabled={false}
                    onChange={handleQuestionChangeCrossTab}
                    onClear={handleQuestionChangeCrossTab}
                    value={selectedQuesCrossTab || undefined}
                    style={{ width: '100%' }}
                    options={surveyQuesCrosstab.map((item) => {
                      return { value: item.id, label: `[${item.id}]${item.text}` };
                    })}
                  />
                </Col>
                {selectedQues && currentQues && <Col className="mobileViewQues">{`[${selectedQues}]` + " " + currentQues}</Col>}
              </Row>
            </div>

            <div className="report-section">
              <div className="chartarea" ref={chartAreaRef}>
                {selectedQuestionaire != '' ? (
                  <>
                    <div className="tabsection">
                      <Radio.Group
                        block
                        options={viewoptions}
                        defaultValue={currentView}
                        onChange={handleViewChange}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    </div>
                    {currentView === 1 ? (
                      <div className="chartview">
                        {Object.keys(chartData).length > 0 && !chartLoader && (
                          <>
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={
                                selectedQuesCrossTab != '' &&
                                  (chartData.qType === 9 ||
                                    chartData.qType === 10 ||
                                    chartData.qType === 4)
                                  ? getChartOptions(chartData)
                                  : createChartData(
                                    'column',
                                    chartData,
                                    chartHeight,
                                    selectedQuesCrossTab
                                  )
                              }
                            />
                            {/* getChartOptions */}
                            <div className="basevalue">
                              <strong>Base:</strong> {chartData?.base}
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="tableview">
                        {isMultiTable ? (
                          <div className="my-table-wrapper">
                            <table>
                              <thead>
                                <tr>
                                  <th rowSpan={2}>Question</th>
                                  {crossMulti.quesText.map((item, index) => {
                                    return (
                                      <th
                                        key={index}
                                        colSpan={crossMulti.groupbystack[0].stack.length}
                                      >
                                        {item}
                                      </th>
                                    );
                                  })}
                                </tr>
                                <tr>
                                  {crossMulti.quesText.map((qt) => {
                                    return (
                                      <Fragment key={`qt_${qt}`}>
                                        {crossMulti.groupbystack[0].stack.map((item, index) => {
                                          const keys = Object.keys(item);
                                          return (
                                            <th className="nfix" key={index}>
                                              {keys}
                                            </th>
                                          );
                                        })}
                                      </Fragment>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {crossMulti.groupbystack.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{item.name}</td>
                                      {item.stack.map((stack, stckindex) => {
                                        const keys = Object.keys(stack);
                                        return (
                                          <Fragment key={stckindex}>
                                            {crossMulti.quesText.map((_, qtindex) => {
                                              return (
                                                <td key={`qtindex_${qtindex}`}>
                                                  {stack[keys].data[qtindex]}%{' '}
                                                  <small>
                                                    (N=
                                                    {stack[keys].count[qtindex]})
                                                  </small>
                                                </td>
                                              );
                                            })}
                                          </Fragment>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <Table
                            dataSource={tableData}
                            bordered
                            columns={columns}
                            pagination={false} // Optional: disable pagination for simplicity
                            scroll={{ x: '170%' }}
                          />
                        )}

                        <div className="basevalue">
                          <strong>Base:</strong> {chartData?.base}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      fontSize: 18,
                      fontWeight: 500,
                      padding: '100px 50px 50px'
                    }}
                  >
                    Please select a questionnaire to view the chart
                  </div>
                )}
                <div className="tableview" style={{ position: 'absolute', left: -9999 }}>
                  {isMultiTable && (
                    <div className="my-table-wrapper">
                      <table id="tbl2excel">
                        <thead>
                          <tr>
                            <th
                              colSpan={
                                crossMulti.quesText.length *
                                crossMulti.groupbystack[0].stack.length +
                                1
                              }
                            >
                              {chartData.title}
                            </th>
                          </tr>
                          <tr>
                            <th rowSpan={2}>Question</th>
                            {crossMulti.quesText.map((item, index) => {
                              return (
                                <th key={index} colSpan={crossMulti.groupbystack[0].stack.length}>
                                  {item}
                                </th>
                              );
                            })}
                          </tr>
                          <tr>
                            {crossMulti.quesText.map((qt) => {
                              return (
                                <Fragment key={`qt_${qt}`}>
                                  {crossMulti.groupbystack[0].stack.map((item, index) => {
                                    const keys = Object.keys(item);
                                    return (
                                      <th className="nfix" key={index}>
                                        {keys}
                                      </th>
                                    );
                                  })}
                                </Fragment>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {crossMulti.groupbystack.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.name}</td>
                                {item.stack.map((stack, stckindex) => {
                                  const keys = Object.keys(stack);
                                  return (
                                    <Fragment key={stckindex}>
                                      {crossMulti.quesText.map((_, qtindex) => {
                                        return (
                                          <td key={`qtindex_${qtindex}`}>
                                            {stack[keys].data[qtindex]}%{' '}
                                            <small>
                                              (N=
                                              {stack[keys].count[qtindex]})
                                            </small>
                                          </td>
                                        );
                                      })}
                                    </Fragment>
                                  );
                                })}
                              </tr>
                            );
                          })}
                          <tr>
                            <td>Base</td>
                            <td>{chartData.base}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {!isMultiTable && (
                    <div className="my-table-wrapper">
                      <table id="tbl2excel">
                        <thead>
                          {selectedQuesCrossTab != '' && (
                            <tr>
                              <th colSpan={columns.length}>{chartData.title}</th>
                            </tr>
                          )}
                          <tr>
                            {columns?.map((item) => {
                              return <th key={item.dataIndex}>{item.title}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {tableData?.map((ditem, index) => (
                            <tr key={`b_${index}`}>
                              {columns?.map((item) => {
                                return (
                                  <td key={item.dataIndex}>
                                    {ditem[item.dataIndex].split('$$$$')[0]}{' '}
                                    {ditem[item.dataIndex].split('$$$$')[1]}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                          <tr>
                            <td>Base</td>
                            <td>{chartData?.base}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fotterbutton">

          <div >
            <Space className="responsive-select1">
              <Button
                type="default"
                disabled={selectedQues === firstQuestionId}
                icon={<LeftOutlined />}
                size="small"
                onClick={() => handleNextQues('previous')}
              >
                Previous
              </Button>

              <Button
                type="default"
                disabled={selectedQues === firstQuestionId}
                icon={<HomeOutlined />}
                size="small"
                onClick={handleHomeButtonClick}
              >
                Home
              </Button>

              <Button
                type="default"
                disabled={selectedQues === lastQuestionId}
                size="small"
                onClick={() => handleNextQues('next')}
              >
                Next
                <RightOutlined />
              </Button>
            </Space>
          </div>
          <div className="copyright-report">&copy; 2025 Curious Insights | All Rights Reserved</div>
        </div>
        <Modal
          title="Select option to download"
          open={isModalOpen}
          onOk={() => handleExcelDownload(qType, true)}
          onCancel={handleCancel}
          okText={`Download ${qType}`}
        >
          <Radio.Group
            onChange={onChange}
            value={isFullSurvey}
            options={[
              {
                value: 1,
                label: 'Selected question'
              },
              {
                value: 2,
                label: 'Full survey'
              }
            ]}
          ></Radio.Group>
        </Modal>
        ;
      </LayoutComp>
    </div>
  );
};

export default Reports;
